import {
  FETCH_ADVERTISERS,
  CREATE_ADVERTISER,
  UPDATE_ADVERTISER
} from './mutations-types'
import firebase from '../../../firebase/main'
import Intercom from '../../../Intercom'
import store from '../../store'
import helpers from '../../../helpers/functions'

export default {
  fetchAdvertisers ({ commit }, payload) {
    return new Promise(resolve => {
      resolve(firebase.Advertisers.fetchAdvertisers())
    })
      .then(res => {
        commit(FETCH_ADVERTISERS, res)
        return true
      })
      .catch(err => helpers.handleError(err))
  },
  createAdvertiser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      resolve(firebase.Advertisers.createAdvertiser(payload))
    })
      .then(res => {
        const advertiser = {
          id: res.id,
          data: payload
        }
        commit(CREATE_ADVERTISER, advertiser)
        return res.id
      })
      .catch(err => helpers.handleError(err))
  },
  updateAdvertiser ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      resolve(firebase.Advertisers.updateAdvertiser(payload))
    })
      .then(res => {
        const user = store.getters.getCurrentUser
        const advertiser = {
          name: payload.data.name,
          website: payload.data.website
        }
        if (store.getters.getIntercom) {
          const intercom = new Intercom(user, {advertiser})
          intercom.hardUpdate()
        }
        commit(UPDATE_ADVERTISER, payload)
        // Note: update state
        commit('audiences/CLEAR_AUDIENCE_STATE')
        commit('campaigns/CLEAR_CAMPAIGNS_STATE')
        dispatch('fetchApiData')
        return true
      })
      .catch(err => helpers.handleError(err))
  }
}
